import React, { useCallback } from 'react';
import { LockOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetPassword } from './ResetPasswordServices';
import { resolveBackendMessage } from '../../Utils/apiMessages';
import { useGlobal } from '../Shared/GlobalContext/GlobalContext';
import { useErrorHandler } from '../../Hooks/useErrorHandler';
import CommonWrapper from '../Shared/CommonWrapper/CommonWrapper';


const ResetPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { token } = useParams();
    const { loading, setLoading } = useGlobal();
    const { handleError } = useErrorHandler();

    const onFinish = useCallback(async (values) => {
        try {
            setLoading(true);
            const payload = await resetPassword(values.newPassword, token);
            {
                const text = resolveBackendMessage(t, payload);
                if (text) message.success(text);
            }
            navigate('/login');
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    }, [navigate, setLoading, token, handleError, t]);

    return (
        <CommonWrapper>
            <Form
                name="reset-password"
                style={{ maxWidth: '100%', margin: '0 auto' }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="newPassword"
                    rules={[
                        { required: true, message: t('please_input_your_new_password') },
                        { min: 6, message: t('password_must_be_at_least_6_characters_long') }
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('new_password')}
                        size="large"
                        style={{ borderRadius: '5px' }}
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    rules={[
                        { required: true, message: t('please_confirm_your_password') },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error(t('the_two_passwords_do_not_match')));
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('confirm_new_password')}
                        size="large"
                        style={{ borderRadius: '5px' }}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        block
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={loading}
                    >
                        {t('reset_password')}
                    </Button>
                </Form.Item>
            </Form>
        </CommonWrapper>
    );
};

export default ResetPassword;
